/* @flow */

export const TAG_TYPE = {
  TOPIC: 'TOPIC',
  USER: 'USER',
  BRAINDATE: 'BRAINDATE',
  CONVERSATION: 'CONVERSATION',
  EVENT: 'EVENT',
  MEMBERSHIP: 'MEMBERSHIP',
  LOCATION: 'LOCATION',
  GRATITUDE: 'GRATITUDE',
  NOTIFICATION: 'NOTIFICATION',
};

export const TAG_ID = {
  LIST: 'LIST',
};

export const ENTITIES_TYPE = {
  braindates: TAG_TYPE.BRAINDATE,
  conversations: TAG_TYPE.CONVERSATION,
  events: TAG_TYPE.EVENT,
  memberships: TAG_TYPE.MEMBERSHIP,
  topics: TAG_TYPE.TOPIC,
  users: TAG_TYPE.USER,
  locations: TAG_TYPE.LOCATION,
  expressionOfGratitude: TAG_TYPE.GRATITUDE,
  notifications: TAG_TYPE.NOTIFICATION,
};
